import { FC } from 'react';
import { ObservableMap } from 'mobx';

import { Card, Flex, TextField } from '@servicetitan/anvil2';

import * as Styles from './configuration-helpers.module.less';

export const DisabledFieldsSection: FC<{ configs: ObservableMap<string> }> = ({ configs }) =>
    configs.size ? (
        <Card
            className={Styles.disabledFieldsSection}
            flexDirection="column"
            flexGrow={1}
            flexBasis={0}
            lg={{ alignSelf: 'flex-start' }}
        >
            <Flex direction="column" gap={6}>
                {[...configs.entries()].map(entry => (
                    <TextField key={entry[0]} label={entry[0]} value={entry[1]} disabled />
                ))}
            </Flex>
        </Card>
    ) : null;
